document.addEventListener('DOMContentLoaded', () => {
	const currentHash = window.location.hash.substring(1);
	const menuLinks = document.querySelectorAll('.menu-link');

	menuLinks.forEach((link) => {
		const linkUrl = link.getAttribute('href');
		const linkHash = linkUrl ? getHashFromUrl(linkUrl) : '';

		if (linkHash !== currentHash) {
			const listItem = link.closest('li');
			if (listItem) {
				listItem.classList.remove('current-menu-item');
			}
		}
	});
});

function getHashFromUrl(url: string): string {
	const hashIndex = url.indexOf('#');
	if (hashIndex !== -1) {
		return url.substring(hashIndex + 1);
	}
	return '';
}
